import UIComponent from "../ui/component";
import goals from "../utils/goals";

export class Transcription extends UIComponent {
    init() {
        this.includeComponents({
            ConfirmDeleteModal: "document@#ConfirmDeleteModal",
        });
        this.recentElement = document.querySelector(
            `.recent-files-list [data-tbx-var-id="${this.getId()}"]`
        );

        this.checkbox = this.element.querySelector(".item-checkbox");
        this.on("click", this.handleRowClick.bind(this));

        this.checkbox.addEventListener("change", (e) => {
            const detail = {
                isChecked: e.target.checked,
                id: this.getId(),
            };
            this.emit("checkboxChange", { detail }, this, true);
        });

        this.checkboxTd?.on("click", (e) => {
            if (
                e.target === this.checkboxTd ||
                !e.target.closest(".item-checkbox")
            ) {
                e.stopPropagation();
                if (!this.checkbox.disabled) {
                    this.checkbox.checked = !this.checkbox.checked;
                    this.checkbox.dispatchEvent(new Event("change"));
                }
            }
        });

        this.delete_route?.on("click", () => this.handleDeleteRoute());

        this.timerInterval = null;
        this.timerFinished = false;

        this.statused = this.element.dataset.status;
        this.updateCheckboxState();
    }

    updateCheckboxState() {
        if (this.checkbox) {
            this.checkbox.disabled = !this.isCompleted();
            if (this.checkbox.disabled) {
                this.checkboxTd?.addClass("checkbox-disabled");
            } else {
                this.checkboxTd?.removeClass("checkbox-disabled");
            }
        }
    }

    formatTime(seconds) {
        if (seconds <= 0) {
            this.time_load?.hide();
            return "00:00";
        }

        if (seconds > 1800) {
            return " > 30 min";
        }

        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (minutes > 0) {
            return `~ ${minutes}:${secs.toString().padStart(2, "0")}`;
        } else {
            return `~ 00:${secs.toString().padStart(2, "0")}`;
        }
    }

    handleDeleteRoute() {
        const url = this.delete_route?.delete_url;
        this.ConfirmDeleteModal?.setupForUrlDelete(url, "one_file");
    }

    getId() {
        return this.id;
    }

    isChecked() {
        return this.checkbox?.checked || false;
    }

    isCompleted() {
        return this.statused === "completed" || this.statused === "failed";
    }

    setChecked(checked = true) {
        if (this.checkbox && !this.checkbox.disabled) {
            this.checkbox.checked = checked;
        }
    }

    handleRowClick(event) {
        if (event.target.closest(".item-checkbox, .dropdown, .actions-btn")) {
            return;
        }
        if (this.url) {
            if (this.statused === "completed") goals.reach("OpenPromo");
            window.location.href = this.url;
        }
    }

    stopTimer() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        if (this.estimate <= 0) {
            this.timerFinished = true;
        }
    }

    startTimer() {
        if (
            this.timerInterval ||
            this.estimate <= 0 ||
            this.isCompleted() ||
            this.timerFinished
        ) {
            return;
        }

        this.timerInterval = setInterval(() => {
            if (this.estimate > 0) {
                this.estimate -= 1;
                if (this.time_load) {
                    this.time_load.element.textContent = this.formatTime(
                        this.estimate
                    );
                }
            } else {
                this.stopTimer();
                if (this.time_load) {
                    this.time_load.element.textContent = "00:00";
                }
            }
        }, 1000);
    }

    setStatus(newStatus) {
        this.element.dataset.status = newStatus;
        this.statused = newStatus;

        this.updateCheckboxState();

        if (!this.isCompleted() && this.estimate > 0) {
            if (this.time_load && this.estimate !== null) {
                this.time_load.element.textContent = this.formatTime(
                    this.estimate
                );
                this.startTimer();
            }
        } else {
            this.stopTimer();
        }
        if (this.recentElement) {
            this.recentElement.dataset.status = newStatus;
        }

        this.updateDropdownMenu();
    }

    updateRow(data) {
        console.log(data);
        this.id = data.id;
        if (this.estimate === null || this.estimate === undefined) {
            this.estimate = data.estimate ? data.estimate - data.passed : null;
        }
        this.setStatus(data.status);
    }

    updateDropdownMenu() {
        Object.keys(this.dropdown_files_pro || {}).forEach((key) => {
            if (key.startsWith("completed_")) {
                const element = this.dropdown_files_pro[key];
                if (this.statused === "completed") {
                    element?.show();
                } else {
                    element?.hide();
                }
            }
        });
    }
}
